// packages
import { createFeed } from './stores.js';
import { findElementInShadowDom } from './utils/render.js';
import { findAndRenderRaceResultElements } from './utils/embed-render-results.js';

// URLs
import { STATE_URL } from './constants.js';

async function main() {
  let container = findElementInShadowDom(
    ".race-embed-container[data-embed-name='ca-statewide-races']"
  );

  if (!container) return;
  const feed = await createFeed(STATE_URL);

  findAndRenderRaceResultElements(/** @type {HTMLElement} */ (container), feed);
}

main().catch(console.error);
